import React from 'react';
import linkifyIt from 'linkify-it';
import tlds from 'tlds';
import { CompositeDecorator, ContentState } from 'draft-js';
import URLUtils from '$/shared/frontend/utils/urls/URLUtils';

const linkify = linkifyIt();
linkify.tlds(tlds);

// Gets all the links in the text, and returns them via the callback
const linkStrategy = (contentBlock: any, callback: Function, contentState: ContentState) => {
  const links = linkify.match(contentBlock.get('text'));
  if (typeof links !== 'undefined' && links !== null) {
    for (let i = 0; i < links.length; i += 1) {
      callback(links[i].index, links[i].lastIndex);
    }
  } else {
    contentBlock.findEntityRanges((character: any) => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
  }
};

const DecoratedLink: React.FC = (props: any) => {
  let url = '';
  if (!props.entityKey) {
    url = props.decoratedText;
  } else {
    const entity = props.contentState.getEntity(props.entityKey).getData();
    url = entity && entity?.url ? entity.url : '';
  }
  if (!URLUtils.isMail(URLUtils.normaliseMail(url))) {
    url = URLUtils.normalizeUrl(url);
  } else {
    url = URLUtils.normaliseMail(url);
  }
  return (
    <a href={url} target='_blank'>
      {props.children}
    </a>
  );
};

const LinkDecorator = (protocolRequired?: boolean) => {
  linkify.set({ fuzzyLink: true });

  if (protocolRequired) {
    linkify.set({ fuzzyLink: false });
  }

  return new CompositeDecorator([
    {
      strategy: linkStrategy,
      component: DecoratedLink,
    },
  ]);
};

export default LinkDecorator;
